<template>
  <v-snackbar 
    v-if="message"
    top 
    right 
    v-model="showMessage" 
    :color="message.type"
  >
    {{message.text}}
  </v-snackbar>
</template>

<script>
export default {
  name: 'TheNotifier',
  computed: {
    message () {
      return this.$store.state.message
    },
    showMessage: {
      get() {
        return !!this.$store.state.message
      },
      set(value) {
        if(!value) this.$store.commit('setMessage', value)
      }
    },
  },
}
</script>